import Highcharts from 'highcharts';

export function toggleLineType(value: string): void {

	// redraw all charts
	Highcharts.charts.forEach(function (chart) {
		if (chart && ((chart.options.xAxis as any)[0]?.type === 'datetime' || chart.options.chart?.renderTo === 'frcst')) {
			if (['spline', 'line'].includes(value)) {
				chart.update({
					chart: {
						type: value,
					},
				});
			}
		}
	});
}
